<ion-header>
  <ion-toolbar>
    <ion-title class="help-title" (click)="onHelpButtonClicked($event)">{{"PUZZLE.help_dialog.title" | translate }}</ion-title>
    <ion-button *ngIf="showXInsteadOfCloseButton" slot="end" fill="clear" shape="round" class="close-help-x-button" (click)="closeDialog(true)">
      <ion-icon slot="icon-only" name="close-outline" size="large"></ion-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid class="help-content">
    <ion-row *ngIf="unsupportedBrowser">
      <ion-col>
        <ion-item lines="none">
          <lib-app-puzzle-compatibillity-warning></lib-app-puzzle-compatibillity-warning>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="noLocalStorage">
      <ion-col>
        <ion-item lines="none">
          <lib-app-puzzle-localstorage-warning />
        </ion-item>
      </ion-col>
    </ion-row>
<!--    <ion-row>-->
<!--      <ion-col>-->
    <ion-row>
      <div #inject></div>
    </ion-row>

    <ion-row *ngIf="framework.puzzleFrameworkConfig.leaderboardEnabled">
      <ion-col>
        <ion-text color="primary"><h2>{{ "PUZZLE.welcome_dialog.leaderboard.title" | translate }}</h2></ion-text>
        <p>{{ "PUZZLE.leaderboard_info_modal.ongoing_rules_strict.message" | translate: { submissionEndLocalized: (leaderboard.leaderboardSubmissionEndLocalizedStr$ | async), submissionStartLocalized: (leaderboard.leaderboardSubmissionStartLocalizedStr$ | async)} }} {{ "PUZZLE.leaderboard_info.tooltip_violation_first_only" | translate }}.</p>
        <ion-text color="primary"><h3>{{ "PUZZLE.welcome_dialog.leaderboard.relaxed" | translate }}</h3></ion-text>
        <p>{{ "PUZZLE.welcome_dialog.leaderboard.tooltip_relaxed" | translate }}</p>
        <ion-text color="primary"><h3>{{ "PUZZLE.welcome_dialog.leaderboard.strict" | translate }}</h3></ion-text>
        <p>{{ "PUZZLE.welcome_dialog.leaderboard.tooltip_strict" | translate }}</p>
      </ion-col>
    </ion-row>

<!--      </ion-col>-->
<!--    </ion-row>-->
    <ion-row *ngIf="buttonBarButtons">
      <ion-col>
        <ion-text color="primary"><h2>{{ "PUZZLE.button_bar.help.title" | translate }}</h2></ion-text>
        <ion-text>{{ "PUZZLE.button_bar.help.text" | translate }}</ion-text>
        <ng-container style="display: table">
          <ng-container *ngFor="let btn of buttonBarButtons">
            <div *ngIf="btn.showInHelp" class="button-help-row">
              <div class="button-help-title" *ngIf="!btn.divider && !btn.spacer">
                <div class="puzzle-help-icon">
                  <ion-button fill="solid" class="puzzle-help-icon-button button-bar-button">
                    <ion-icon name="{{btn.icon}}" class="button-bar-icon {{btn.name}}" slot="icon-only"></ion-icon>
                  </ion-button>
                </div>
              </div>
              <div class="button-help-description" *ngIf="!btn.divider && !btn.spacer">
                <span>{{btn.help.title | translate}}</span> {{btn.help.text | translate}}
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="sideNavButtons">
      <ion-col>
        <ion-text color="primary"><h2>{{ "PUZZLE.sidenav.help.title" | translate }}</h2></ion-text>
        <ion-text>{{ "PUZZLE.sidenav.help.text" | translate }}</ion-text>
        <div style="display: table">
          <ng-container *ngFor="let btn of sideNavButtons">
            <div *ngIf="btn.showInHelp"  class="button-help-row">
              <div class="button-help-title" *ngIf="!btn.divider && !btn.spacer">
                <div class="puzzle-help-icon">
                  <ion-button fill="clear" class="puzzle-help-icon-button">
                    <ion-icon class="sidenav-icon {{btn.name}}" name="{{btn.icon}}" slot="icon-only"></ion-icon>
                  </ion-button>
                </div>
              </div>
              <div class="button-help-description" *ngIf="!btn.divider && !btn.spacer">
                <span>{{btn.help.title | translate}}</span> {{btn.help.text | translate}}
              </div>
            </div>
          </ng-container>
        </div>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="showHelpFeedback">
      <ion-col class="help-feedback">
        <div>
          <ion-text class="help-feedback-title" color="primary"><h2>{{ "PUZZLE.feedback.help.title" | translate }}</h2></ion-text>
          <ion-text class="help-feedback-text" [innerHTML]="'PUZZLE.feedback.help.text' | translate"></ion-text><br/>
          <div class="help-feedback-button-wrapper">
            <ion-button class="help-feedback-button" fill="outline" href="{{ replace_date('PUZZLE.feedback.button.href' | translate) }}">{{ "PUZZLE.feedback.button.text" | translate }}</ion-button>
          </div>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="ion-margin-bottom"></ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer *ngIf="!showXInsteadOfCloseButton">
  <div class="puzzle-modal-buttons">
    <ion-button (click)="closeDialog(true)">
      {{"PUZZLE.help_dialog.close_button" | translate }}
    </ion-button>
  </div>
</ion-footer>
